/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon16Solid = forwardRef('ArrowUiCornerOutUpRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.437 1c-.12.31-.187.647-.187 1 0 .788.331 1.498.862 2L6.055 6.054a2.75 2.75 0 1 0 3.89 3.89L12 7.888A2.742 2.742 0 0 0 15 8.563V11.5a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 1 11.5v-7A3.5 3.5 0 0 1 4.5 1h2.937Z" }),
        React.createElement("path", { d: "M13 4.414V6a1 1 0 1 0 2 0V3a2 2 0 0 0-2-2h-3a1 1 0 1 0 0 2h1.586L7.293 7.293a1 1 0 0 0 1.414 1.414L13 4.414Z" })));
});
